import React from 'react';
import { Button, Box, Typography, Divider } from '@mui/material';
import { useAppDispatch } from '../../store/hooks';
import { continueAsGuest } from '../../services/authService';
import { useNavigate } from 'react-router-dom';

const GuestButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleContinueAsGuest = () => {
    continueAsGuest(dispatch);
    navigate('/');
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Divider sx={{ my: 2 }}>
        <Typography variant="body2" color="text.secondary">
          OR
        </Typography>
      </Divider>
      <Button
        fullWidth
        variant="outlined"
        size="large"
        onClick={handleContinueAsGuest}
        sx={{ mt: 2, py: 1.5 }}
      >
        Continue as Guest
      </Button>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1, textAlign: 'center' }}>
        You can create an account later to save your progress
      </Typography>
    </Box>
  );
};

export default GuestButton;

